const JSON5 = require('json5')

export default (context, inject) => {
  inject('JSON5', JSON5)
  // For Nuxt <= 2.12, also add 👇
  context.$JSON5 = JSON5
  const JSONify = (stringToParse) => {
    let ret
    try {
      if (typeof stringToParse === 'object' && stringToParse !== null) {
        // already an object, no need to parse
        ret = stringToParse
      } else {
        // this is not an object.  attempt to parse it
        ret = JSON5.parse(JSON5.parse(stringToParse))
      }
    } catch (error) {
      // last ditch effort to parse it
      ret = JSON5.parse(stringToParse)
    }
    return ret
  }
  inject('JSONify', JSONify)
}
